import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { ICheckpointCondition, ICheckpointRange } from '@fi-shared/checklist/checklist-v2';
import { FiComponentsContainer } from '@fi-shared/fi-components-container';
import { CheckpointType } from '@fi-shared/checklist/checklist-enum';
import { Subject } from 'rxjs';
import { FiDialogsService } from '@fi-shared/fi-dialogs';
import { AppTextService } from '@fi-shared/app-text';
import { FiCheckpoint2HelperService } from '@fi-shared/checklist/fi-checkpoint2-helper.service';

@Component({
    selector: 'fi-checkpoint-edit-checkpoint-conditions-tab',
    templateUrl: './conditions-tab.component.html',
    styleUrls: ['./conditions-tab.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-checkpoint-edit-checkpoint-conditions-tab' },
    providers: [{ provide: FiComponentsContainer, useExisting: FiCheckpointEditConditionsTabComponent }],
    standalone: false,
})
export class FiCheckpointEditConditionsTabComponent extends FiComponentsContainer {
    @Input() checkpointRanges: ICheckpointRange[] = [];
    @Input() checkpointType: CheckpointType;
    @Input() isQRCodeEnabled: boolean;
    @Input() checkpointConditions: ICheckpointCondition[] = [];
    @Output() checkpointConditionsChange = new EventEmitter<ICheckpointCondition[]>();
    @Input() updateConditionTypeOptions$ = new Subject<void>();

    constructor(
        private fiCheckpoint2HelperService: FiCheckpoint2HelperService,
        private fiDialogsService: FiDialogsService,
        private appTextService: AppTextService,
    ) {
        super();
    }

    addCheckpointCondition() {
        this.checkpointConditions.push(this.fiCheckpoint2HelperService.getDefaultCondition());
        this.checkpointConditionsChange.emit(this.checkpointConditions);
    }

    openConfirmDeleteConditionDialog(conditionIndex: number) {
        this.fiDialogsService
            .confirmSimpleDelete({
                headerText: this.appTextService.get('checklist.checkpoint_condition_delete_header'),
                messageText: this.appTextService.get('checklist.checkpoint_condition_delete_confirm_message'),
                preventUppercaseButtonLabel: true,
                config: {
                    panelClass: ['fi-confirm-delete-dialog-panel', 'fi-rounded-dialog-panel'],
                    autoFocus: false,
                },
            })
            .onYesButtonClick(() => this.deleteCondition(conditionIndex));
    }

    private deleteCondition(conditionIndex: number) {
        this.checkpointConditions.splice(conditionIndex, 1);
        this.checkpointConditionsChange.emit(this.checkpointConditions);
    }
}
